<template>
  <div class="">
    <div class="container remove-margins">
      <div v-if="petsListComp">
        <div v-if="petsListComp.length < 1">
          <h4>No pets added yet, please Add new pet</h4>
        </div>

        <div v-if="petsListComp && petsListComp.length > 0">
          <div
            class="col-sm-6 col-md-5 col-lg-4 col-xs-12 remove-margins"
            v-for="(pet, index) in petsListComp"
          >
            <PetProfileCard
              v-bind:petId="pet.PetId"
              :key="pet.PetId"
            ></PetProfileCard>
          </div>
        </div>
        <br />
      </div>
    </div>
    <div
      class="container remove-margins"
      v-if="petsListComp && petsListComp.length > 0"
    >
      <br />
      <a class="btn-success btn-lg" href="https://www.dupaws.com/findsitters"
        >Find and Book Pet Sitters</a
      >
    </div>
  </div>
</template>

<script>
import store from "../../data/store";
import PetProfileCard from "./components/PetProfileCard.vue";
import customerApi from "../../services/customerApi.js";

export default {
  data() {
    return {};
  },
  mounted() {
    this.$ga.page(this.$router);
    setTimeout(function () {
      customerApi.getPetsList();
    }, 20); //Adding delay to give room for Add New Pet to delete init entry if Owner didn't save.
  },
  methods: {
    addNewPet: function () {
      this.$router.push({ path: "/pets-view/addpet" });
    },
  },
  components: {
    PetProfileCard,
  },
  computed: {
    petsListComp: function () {
      if (store.getters.PetsList) return store.getters.PetsList;
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// MyPets.vue?7e439dac